import {
    productImageBackgroundGradient,
    productImageHoverBackgroundGradient,
} from "../../../design-tokens/01.colors/colors";
import { Box } from "../../layout/box/Box";
import { NextImage } from "../../media-and-icons/image/NextImage";
import { type CSSProperties, memo } from "react";

type ProductImageFrameProps = {
    src: string;
    priority?: boolean;
    alt: string;
    objectFit?: CSSProperties["objectFit"];
    quality?: number;
    isHovering?: boolean;
    sizes?: string[];
};

export const ProductImageFrame = memo(
    ({
        src,
        priority = false,
        alt,
        objectFit = "contain",
        quality = 75,
        isHovering = false,
        sizes = ["100vw", "100vw", "25vw", "50vw"],
    }: ProductImageFrameProps) => {
        return (
            <Box
                background={
                    isHovering
                        ? productImageHoverBackgroundGradient
                        : productImageBackgroundGradient
                }
                width="100%"
                sx={{
                    aspectRatio: "4/5",
                    overflow: "hidden",
                }}
            >
                <NextImage
                    src={src}
                    alt={alt}
                    objectFit={objectFit}
                    quality={quality}
                    priority={priority}
                    fill
                    sizes={sizes}
                    style={{
                        objectFit,
                        width: "100%",
                        height: "auto",
                    }}
                />
            </Box>
        );
    }
);

ProductImageFrame.displayName = "ProductImageFrame";

export default ProductImageFrame;
